const headerStyle = () => {
    return {
        borderColor: '#a81933'
    };
};

const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

export const columns = [
    {    
        dataField: 'Name',
        text: 'Name',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {    
        dataField: 'Description',
        text: 'Description',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    }
];
    
export const sorting = [{
    dataField: 'name',
    order: 'desc'
}];